// extracted by mini-css-extract-plugin
export default {"wrapper":"Image-module__wrapper___pPQV3","image":"Image-module__image___LMeO6","imageDescription":"Image-module__imageDescription___iiRzj"};